import React from "react"
import { motion } from "framer-motion"
import { fadeIn } from "../utils/motion"
import { stats } from "../constants"
import { SectionWrapper } from "../hoc"
const Achievements = () => {
  return (
    <div className="px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] pb-12 md:pb-20 history-section w-full ">
      <div className="mt-20 lg:mt-32 flex w-full">
        <div className="inline-block">
          <motion.h1
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("up", "spring", 0.4, 0.5)}
            className="font-medium history-heading text-left font-leading"
          >
            <span className="leading-none block tracking-wide">
              <span className="tracking-wide">From the Ground</span>
            </span>
            <span className="leading-tight block tracking-wide">
              <span className="tracking-wide">Up: A Brief History</span>
            </span>
          </motion.h1>
          <div className="mt-20 lg:mt-36 history-content flex flex-row flex-wrap text-left overflow-hidden font-leading">
            {stats.map((data, index) => (
              <motion.div
                key={index}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={fadeIn("up", "spring", index * 0.3, 0.8)}
              >
                <h3 className="quote-title text-xl sm:text-4xl lg:text-5xl font-semibold leading-none">
                  <span>{data.title}</span>
                </h3>
                <p className="text-xs sm:text-lg mt-5 leading-tight lg:leading-normal xl:leading-loose tracking-wider md:tracking-widest max-w-[260px]">
                  <span>{data.description}</span>
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionWrapper(Achievements, "achievements")
